import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MembershipDiscountOfferPage } from './membership-discount-offer.page';

const routes: Routes = [
  {
    path: '',
    component: MembershipDiscountOfferPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MembershipDiscountOfferPageRoutingModule {}
